import React from 'react'
import { useIntl } from 'react-intl'
import { Link, generatePath } from 'react-router'

import { ROUTES } from 'consts'
import { formatPrice } from 'utils'
import ProductImage from 'components/Product/ProductImage'
import messages from 'views/CartV2/messages'
import QuantityControls from './QuantityControls'

const ProductRow = ({ item }) => {
  const { formatMessage } = useIntl()
  const { product, totalPrice } = item
  const { image } = product

  const productPath = generatePath(ROUTES.PRODUCT_DETAILS, { id: product.id })

  return (
    <div
      data-test-id={`cart_product-row#${product.id}`}
      className="flex gap-2 py-6 pl-2 pr-3 lg lg:gap-4 lg:p-4"
    >
      <Link
        to={productPath}
        className="flex grow shrink-0 w-[72px] h-[72px] lg:w-[48px] lg:h-[48px]"
      >
        <ProductImage
          product={product}
          imageSrc={image?.smallUrl}
          suppressImgGraying
        />
      </Link>
      <div className="flex flex-col gap-3 w-full lg:flex-row lg:justify-between lg:items-center">
        <div className="inline lg:flex lg:flex-col lg:gap-1">
          <span className="text-13 text-grey-800 mr-2 lg:text-label-11 lg:m-0">
            {product.brand}
          </span>
          <Link to={productPath}>
            <span className="text-13 hover:text-green-700">{product.name}</span>
          </Link>
        </div>
        <div className="flex justify-between lg:flex-row-reverse lg:justify-normal lg:gap-4 ">
          <div className="flex flex-col lg:text-right lg:w-[100px]">
            <span className="text-[14px] leading-6 font-semibold">
              {formatPrice(totalPrice.net)}
            </span>
            <span className="text-label-11 text-grey-800">
              {formatMessage(messages.gross, {
                price: formatPrice(totalPrice.gross),
              })}
            </span>
          </div>
          <div className="max-w-[132px] lg:max-w-[140px]">
            <QuantityControls item={item} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductRow
